import React, {Component} from 'react';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import styles from '../AccountPageStyles';
import _ from 'lodash';
import {setPreference} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';
import {Settings as SettingsData} from '../AccountPageSectionsData';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import * as routes from 'App/routeConstants';
import {Link} from 'react-router';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import Toggle from 'material-ui/Toggle';

@connectWithRouter(
  state => ({
    autoHeightTextElement: state.user.autoHeightTextElement,
    limitPageWidth: state.user.limitPageWidth,
    optimizeImageSize: state.user.optimizeImageSize,
    accounts: state.accountPage.accounts,
  }),
  {updateUserData}
)
export class Settings extends Component {
  constructor(props) {
    super();
    const {accounts} = props;
    this.state = {
      selectedSellerId: _.first(_.keys(accounts)),
    };
  }

  handleAutoHeightTextElementsChange = (event, value) => {
    setPreference('AUTO_HEIGHT_TEXT_ELEMENTS', value).then(response => {
      if (response.success) {
        const {updateUserData} = this.props;
        updateUserData(response.user);
      }
    });
  };

  handleLimitPageWidthChange = (event, value) => {
    setPreference('LIMIT_PAGE_WIDTH', value).then(response => {
      if (response.success) {
        const {updateUserData} = this.props;
        updateUserData(response.user);
      }
    });
  };

  handleOptimizeImageSizeChange = (event, value) => {
    setPreference('ENABLE_IMAGE_RESIZE', value).then(response => {
      if (response.success) {
        const {updateUserData} = this.props;
        updateUserData(response.user);
      }
    });
  };

  handleEbayAccountChange = (event, index, selectedSellerId) => {
    this.setState({selectedSellerId});
  };

  render() {
    const {autoHeightTextElement, accounts, limitPageWidth, optimizeImageSize} = this.props;
    const {selectedSellerId} = this.state;
    return (
      <div style={styles.pageContentContainer}>
        <div style={styles.h1}>Settings</div>
        <Paper style={styles.card}>
          <div style={styles.h2}>Editor Settings</div>
          <Toggle
            toggled={limitPageWidth}
            style={{marginTop: 15, marginBottom: 15}}
            labelPosition="right"
            onToggle={this.handleLimitPageWidthChange}
            label={
              <span>
                <strong>Limit page width</strong> - Page width can’t be greater than 950px or less than 750 px
              </span>
            }
          />
          <Toggle
            toggled={optimizeImageSize}
            style={{marginTop: 15, marginBottom: 15}}
            labelPosition="right"
            onToggle={this.handleOptimizeImageSizeChange}
            label={
              <span>
                <strong>Optimize image size</strong> - The size of the images on your template is optimized to speed
                loading time of your listings{' '}
              </span>
            }
          />
        </Paper>
        <Paper style={styles.card}>
          <div style={styles.h2}>Description Element</div>
          <div>
            <div style={{marginTop: 15, marginBottom: 15}}>
              When description text is long, and does not fit the description box in listing’s design:
            </div>
            <RadioButtonGroup
              name={'description element radio button group'}
              defaultSelected={autoHeightTextElement}
              onChange={this.handleAutoHeightTextElementsChange}
            >
              <RadioButton
                value={false}
                label={
                  <span>
                    <strong>Fit text to box</strong> - box size stays the same and gets a <strong>scroll bar</strong>
                  </span>
                }
                style={styles.radioButton}
              />
              <RadioButton
                value
                label={
                  <span>
                    <strong>Show full text</strong> - box height increases to show the <strong>whole text</strong> while
                    moving other elements down the page
                  </span>
                }
                style={styles.radioButton}
              />
            </RadioButtonGroup>
          </div>
        </Paper>
        {!_.isEmpty(accounts) && (
          <Paper style={styles.card}>
            <div style={styles.h2}>Description Cleaner</div>
            <div>
              <div style={{marginTop: 15, marginBottom: 15}}>
                You can remove texts that repeat in many of your listing's descriptions.
              </div>
            </div>
            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
              <SelectField
                style={{marginRight: 20, top: 8}}
                floatingLabelText="eBay Account"
                value={selectedSellerId}
                onChange={this.handleEbayAccountChange}
                autoWidth
              >
                {_.map(accounts, ({UserID}) => {
                  return <MenuItem key={UserID} value={UserID} primaryText={UserID} />;
                })}
              </SelectField>
              <RaisedButton
                label="clean"
                containerElement={
                  <Link to={{pathname: routes.MyAccount.ClearDescription, query: {selectedSellerId}}} />
                }
              />
            </div>
          </Paper>
        )}
      </div>
    );
  }
}

export default _.assign(Settings, SettingsData);
